import { render, staticRenderFns } from "./GraficoPie.vue?vue&type=template&id=1e5c5494&"
import script from "./GraficoPie.vue?vue&type=script&lang=ts&"
export * from "./GraficoPie.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1e5c5494', component.options)
    } else {
      api.reload('1e5c5494', component.options)
    }
    module.hot.accept("./GraficoPie.vue?vue&type=template&id=1e5c5494&", function () {
      api.rerender('1e5c5494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboardEsmax/TiposGraficos/GraficoPie.vue"
export default component.exports